import { Env } from '@repo/types/config';
import { WidgetStudy } from '@repo/types/models';
import { Widget } from '@repo/widget';
import { Root } from 'react-dom/client';
import i18n from '../i18/index';

import { I18nextProvider, useTranslation } from 'react-i18next';

export function drawEmbed(
    root: Root,
    fullPage: boolean,
    demoMode: boolean,
    analyticsId: string,
    study: WidgetStudy,
    env: Env
) {
    root.render(
        <I18nextProvider i18n={i18n}>
            <EmbedWrapper
                fullPage={fullPage}
                demoMode={demoMode}
                analyticsId={analyticsId}
                study={study}
                env={env}
            />
        </I18nextProvider>
    );
}

function EmbedWrapper({
    analyticsId,
    demoMode,
    env,
    fullPage,
    study,
}: {
    fullPage: boolean;
    demoMode: boolean;
    analyticsId: string;
    study: WidgetStudy;
    env: Env;
}) {
    const { t } = useTranslation();

    return (
        <Widget
            translation={t}
            env={env}
            study={study}
            analyticsId={analyticsId}
            demoMode={demoMode}
            fullPage={fullPage}
        />
    );
}
